import { useEffect, useState } from 'react';

const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

const readMatch = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(TOUCH_QUERY).matches
    : false;

export const useIsTouchDevice = (): boolean => {
  const [isTouch, setIsTouch] = useState<boolean>(readMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mediaQuery = window.matchMedia(TOUCH_QUERY);
    const handleChange = (event: MediaQueryListEvent) => setIsTouch(event.matches);

    setIsTouch(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isTouch;
};
